import script from "./BlockILEM.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockILEM.vue?vue&type=script&setup=true&lang=js"

import "./BlockILEM.vue?vue&type=style&index=0&id=085cdb76&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1694328059/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085cdb76"]])

export default __exports__